export default {
  translation: {
    'form.validation.required': '{{field_name}} 是必须的',
    'form.validation.format':
      '{{field_name}}格式错误，内容包含系统不支援的符号',
    'form.validation.maxlength': '{{field_name}} 太长',
    'form.validation.minlength': '{{field_name}} 太短',
    'form.validation.invalid': '{{field_name}} 无效',
    'form.validation.unique': '{{field_name}} 已被选用，请重新输入。',
    'membership.profile.optional_field': '(选填)',
    'dropdown.hint': '请选择',

    'member_points.title': '会员点数',
    'member_points.unit': '点',
    'member_points.point_balance': '现有总点数',
    'member_points.point_history': '点数记录',
    'member_points.fields.date': '日期',
    'member_points.rule': '点数规则说明',
    'member_points.display.expire_point': '点将于',
    'member_points.display.successive_expire_point': '点将于',
    'member_points.fields.expire': '到期',
    'member_points.fields.expired': '点数过期',
    'member_points.fields.successive_expire': '后陆续到期',
    'member_points.fields.remarks': '点数更动原因',
    'member_points.fields.value': '点数',
    'member_points.fields.expiry_date': '到期日',
    'member_points.fields.member_point_expired': '点数过期',
    'member_points.fields.auto_reward': '于订单',
    'member_points.fields.auto_reward_seconds': '获得点数',
    'member_points.no_data': '没有任何记录',
    'member_points.equal_cash': '等值 {{money}}',
    'member_points.redeem_cash_description':
      '{{costPoint}} 点可折抵 {{discountMoney}}。',
    'member_points.fields.revert_member_point': '回补点数；已退货订单',
    'member_points.fields.revert_member_point.return': '回补点数；已取消订单',
    'member_points.fields.revert_member_point.order_split':
      '回补点数；来自拆单',
    'member_points.fields.revert_member_point.order_edit':
      '回补点数；来自编辑订单',
    'member_points.fields.revert_member_point.return_order_revert':
      '回补点数；来自退货',
    'member_points.fields.revert_member_point.order': '回补点数；来自订单',
    'member_points.fields.product_review_reward': '完成订单 <a></a> 的评价',
    'member_points.fields.member_info_reward': '会员信息奖赏会员点数',
    'store_credits.fields.display.never_expired': '永不过期',
    'member_points.fields.order_redeemed': '使用点数兑换赠品于订单',
    'member_points.fields.redeemed_to_cash': '使用点数折现于订单',
    'member.center.load.more': '载入更多',
    'store_credits.fields.never_expires_point': '点永不过期',
    'member_points.display.redeem_btn': '兑换赠品',
    'promotions.page.term.confirm': '确认',

    'store_credits.title': '商店购物金',
    'store_credits.credit_balance': '现有购物金',
    'store_credits.credit_history': '购物金纪录',
    'store_credits.fields.date': '日期',
    'store_credits.fields.remarks': '购物金项目',
    'store_credits.fields.value': '购物金款项',
    'store_credits.fields.expiry_date': '到期日',
    'store_credits.fields.balance': '购物金馀额',
    'store_credits.fields.order_prefix': '已使用购物金在此笔订单',
    'store_credits.fields.welcome_credit': '新加入会员购物金',
    'store_credits.fields.member_referral_credit': '推荐新顾客进行消费',
    'store_credits.fields.member_info_quick_completion_credit':
      '会员信息奖赏购物金',
    'store_credits.fields.welcome_member_referral_credit':
      '透过推荐连结注册成功',
    'store_credits.fields.birthday_credit': '生日购物金',
    'store_credits.fields.user_credit_expired': '购物金过期',
    'store_credits.fields.never_expires': '永不过期',
    'store_credits.fields.auto_reward_prefix': '订单 ',
    'store_credits.fields.auto_reward': ' 获得购物金',
    'store_credits.fields.revert_credit': '回补购物金；已取消订单',
    'store_credits.fields.revert_credit.return': '回补购物金；已退货订单',
    'store_credits.fields.revert_credit.order_split': '回补购物金；来自拆单',
    'store_credits.fields.revert_credit.order_edit': '回补购物金；来自编辑订单',
    'store_credits.fields.revert_credit.order': '回补购物金；来自订单',
    'store_credits.fields.revert_credit.return_order_revert':
      '回补购物金；来自退货',
    'store_credits.fields.product_review_reward': '完成订单 <a></a> 的评价',
    'store_credits.no_data': '没有任何记录',
    'store_credits.bulk_imported': '手动新增购物金',

    'member_point.list.empty.description': '结帐累积点数获得更多优惠！',
    'store_credits.list.empty.description': '结帐累积购物金获得更多优惠！',
    'member_center.list.empty.buttonText': '马上逛逛',
    // Member Profile
    'member_profile.member_info.title': '会员信息奖赏',
    'member_profile.member_info.name': '姓名',
    'member_profile.member_info.email': '电邮',
    'member_profile.member_info.mobile': '手机号',
    'member_profile.member_info.gender': '性别',
    'member_profile.member_info.birthday': '生日',
    'member_profile.member_info.symbol': '、',
    'member_profile.member_info.hint.both':
      '填写会员信息「{{fields}}」，並且订阅「{{subscriptions}}」，完毕可获得 {{rewards}}',
    'member_profile.member_info.hint.fields_only':
      '填写会员信息「{{fields}}」，完毕可获得 {{rewards}}',
    'member_profile.member_info.hint.subscriptions_only':
      '订阅「{{subscriptions}}」，完毕可获得 {{rewards}}',
    'member_profile.member_info.sent': '待信息检查完成，将发放会员信息奖赏！',
    'member_profile.member_info.user_credits': '${{count}} 元购物金',
    'member_profile.member_info.member_points': '{{count}} 点会员点数',
    'member_profile.member_info.coupons': '{{count}} 张优惠券',
    'member_profile.member_info.subscription.email': '电邮',
    'member_profile.member_info.subscription.sms': 'SMS',
    'member_profile.member_info.subscription.line': 'LINE',
    'member_profile.member_info.subscription.facebook': 'Facebook Messenger',
    'member_profile.member_info.subscription.whatsapp': 'WhatsApp',
    'member_profile.member_referral.discount': '会员推荐优惠',
    'member_profile.member_referral.rules': '活动规则说明',
    'member_profile.member_referral.code.copy_and_share':
      '复制并分享连结给朋友，推荐对象和你将获得购物金。',
    'member_profile.member_referral.code.remarks': '活动规则说明',
    'member_profile.member_referral.generate': '推荐连结',
    'member_profile.member_referral.generate.success': '产生成功',
    'member_profile.member_referral.copy': '复制连结',
    'member_profile.member_referral.copy.success': '复制成功',
    'membership.profile.email': '电邮',
    'membership.profile.verification_hint':
      '若您更改电邮，储存后需进行验证，完成验证后电邮将会立即更新为 {{unconfirmedEmail}}',
    'membership.profile.verified_success': '验证完成',
    'membership.profile.not_verified_yet': '尚未验证',
    'membership.profile.send_verification_email': '发送验证信',
    'users.save.email_verification.success':
      '变更已储存, 电邮会在验证成功后更新',
    'users.save.email_verification.send': '验证信已寄出',
    'user.sign_up.email_verification.dialog.title': '验证信已寄至 {{email}}',
    'user.sign_up.email_verification.dialog.description':
      '请立即完成收信验证，即可更新电邮！若没收到，请再次更改电邮并储存。',
    'user.sign_up.email_verification.dialog.confirm': '确定',

    'users.membership.member_info.title': '会员信息奖赏',
    'users.membership.member_info.hint':
      '填写以下会员信息：{{fields}}，填写完毕可获得 {{rewards}}',
    'users.membership.member_info.sent': '待信息检查完成，将发放会员信息奖赏！',
    'users.membership.member_info.symbol': '、',
    'users.membership.member_info.name': '姓名',
    'users.membership.member_info.email': '电邮',
    'users.membership.member_info.mobile': '手机号',
    'users.membership.member_info.gender': '性别',
    'users.membership.member_info.gender.male': '男',
    'users.membership.member_info.gender.female': '女',
    'users.membership.member_info.gender.other': '不透露',
    'users.membership.member_info.birthday': '生日',
    'users.membership.member_info.password': '密码',
    'users.membership.member_info.password.change': '设定新的密码',
    'users.membership.member_info.account_binding': '第三方註册',
    'users.membership.member_info.user_credits': '${{count}} 元购物金',
    'users.membership.member_info.member_points': '{{count}} 点会员点数',
    'users.membership.member_info.coupons': '{{count}} 张优惠券',
    'users.membership.forget_password.email_sent':
      '我们已寄出帐号验证信至{{email}}，\n请收信以继续重设密码！',
    'users.member.normal-level': '一般会员',
    'users.membership.expiry_date': '会籍到期日',
    'users.membership.expire.unlimited': '永久有效',
    'users.membership.expire.month_valid': '（效期 {{months}} 个月)',
    'users.membership.tier.expire.date.description':
      '自动更新时间为订单完成付款后的隔日凌晨，若因取消订单或退货未达成升级条件则不会升级。',
    'users.membership.tier.expire.date.auto_downgrade.description':
      '自动更新时间为订单转为已完成后的隔日凌晨，若因取消订单或退货未达成升级条件则不会升级。',
    'users.membership.tier.extension.date.description':
      '会籍到期时，订单状态若因取消订单或退货未达成续会条件则不会续会。',
    'users.membership.offer.discount': '专属优惠',
    'users.membership.upgrade.next_tier': '升级至 {{tier_name}}',
    'users.membership.upgrade.next_tier.discount': '，享购物 {{discount}} 折',
    'users.membership.extension.condition': '续会条件',
    'users.membership.extension.status': '续会状态',
    'users.membership.max_level_tier': '恭喜您已至最高阶会员!',
    'users.membership.spending_within_months':
      '{{months}} 个月内累积消费额达 {{spending}} 即可升级',
    'users.membership.spending_single_purchase':
      '单次消费额达 {{spending}} 即可升级',
    'users.membership.all.spending_within_months':
      '{{months}} 个月内累积消费额达 {{spending}}',
    'users.membership.all.spending_single_purchase':
      '单次消费额达 {{spending}}',
    'users.membership.extend_valid_period':
      '会籍效期{{months}}个月内{{type}}消费额达 {{ spending }}',
    'users.membership.within_interval': '累积',
    'users.membership.single_purchase': '单次',
    'users.membership.all_tiers': '查看所有会员等级规则',
    'users.membership.all_tiers.condition': '会员等级规则',
    'users.membership.all_tiers.description':
      '会籍期效内若没达成续会条件，将会自动降级',
    'users.membership.tier.shopping_discount': '购物 {{discount}} 折',
    'users.membership.tier.upgrade.condition': '本阶升级条件 :',
    'users.membership.tier.upgrade.condition.dollar':
      '目前没有高于 {{ dollar }} 的订单，',
    'users.membership.tier.upgrade.condition.continue': '继续逛逛',
    'users.membership.tier.extend': '已达 {{tier}} 续会条件？',
    'users.membership.tier.upgrade.to_next_level.single': '已达升级条件',
    'users.membership.tier.upgrade.to_next_level.within':
      '{{month}} 个月内累积消费额',
    'users.membership.tier.upgrade.completed': '符合升级资格',
    'users.membership.tier.upgrade.gap_dollar': '差 {{ dollar }} 升级',
    'users.membership.tier.expire.date': '有效期限 :',
    'users.membership.tier.extend.condition': '续会条件 :',
    'users.membership.tier.extend.single_purchase':
      '会籍效期 {{month}} 个月内没有高于 {{dollar}} 的订单',
    'users.membership.tier.extend.single_purchase.can_extend':
      '会籍效期 {{month}} 个月内有高于 {{dollar}} 的订单，到期时将自动续会',
    'users.membership.tier.extend.top_level.single_purchase':
      '会籍内没有高于 {{dollar}} 的订单，',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      '会籍内有高于 {{dollar}} 的订单，恭喜达成！到期时将自动续会',
    'users.membership.tier.extend.within_interval':
      '会籍效期 {{month}} 个月内累积消费 {{spending}}，差 {{dollar}} 续会',
    'users.membership.tier.extend.within_interval.can_extend':
      '会籍效期 {{month}} 个月内累积消费已达 {{dollar}}，到期时将自动续会',
    'users.membership.tier.extend.top_level.within_interval':
      '差 {{dollar}} 续会',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      '恭喜达成！到期时将自动续会',
    'users.membership.tier.expire.month': '{{month}} 个月',
    'users.membership.tier.discount_percentage.caption': '{{ value }}折',

    'membership.profile.birthday': '生日日期',
    'birthday_picker.year.placeholder': '年',
    'birthday_picker.month.placeholder': '月',
    'birthday_picker.date.placeholder': '日',
    'form.validation.birthday.required': '生日日期 是必须的',
    'form.validation.birthday.invalid': '生日日期 无效',
    'form.validation.birthday.invalid.minimum_age_limit':
      '生日日期无效，需大于 {{minimumAgeLimit}} 岁',
    'users.birthday.faq': '您需达到一定年龄才能在网店注册及购物。',
    'membership.edit.send_me_check_mode': '寄发验证码',
    'membership.edit.select_saved_mobile_number': '选择储存的联络电话',
    'session.mobile_signup.check_mobile.title':
      '请确认您的手机号码是否输入正确，我们将传送简讯到以下手机号码',
    'session.mobile_signup.check_mobile.your_number': '您的手机号码',
    'session.mobile_signup.check_mobile.send_code': '寄发验证码',
    'session.mobile_signup.check_mobile.go_back.1': '若手机号码有误，请回',
    'session.mobile_signup.check_mobile.go_back.2': '上一步',
    'session.mobile_signup.check_mobile.go_back.3': '修改',
    'session.mobile_signup.check_mobile.go_back.3.simplified': '修改',
    'session.mobile_signup.input_code.hint': '请输入收到的简讯验证码',
    'session.mobile_signup.input_code.hint.simplified': '请输入您收到的验证码',
    'session.mobile_signup.input_code.placeholder': '验证码',
    'session.mobile_signup.input_code.submit': '送出',
    'session.mobile_signup.input_code.resend.countdown':
      '重发验证码 ({{resendCountdown}}秒)',
    'session.mobile_signup.input_code.resend.countdown.simplified':
      '重新发送({{resendCountdown}}秒）',
    'session.mobile_signup.input_code.resend': '重发验证码',
    'session.mobile_signup.input_code.resend.simplified': '重新发送',
    'session.forget_passowrd.check_phone.error': '手机号码无效，请重新确认',
    'session.mobile_center.check_phone.error': '此手机号码已注册过',
    'user.sign_up.check_phone.error':
      '此为现有手机号码，请重新填写需要更换的号码。',
    'membership.profile.mobile.number.verified':
      '会员手机验证完成，并将取代已储存的电话号码以利辨识',
    'membership.profile.delivery_addresses': '储存的地址',
    'users.add.delivery_address.maximum': '最多只能有五个送货地址',
    'users.add.delivery_address': '新增送货地址',
    'checkout.address.recipient': '收件人',
    'checkout.address.recipient_phone': '收件人电话号码',
    'member_profile.line.subscribe.error.already_in_used':
      '此 LINE 帐号已被既有会员使用，请联繫店家！',
    'member_profile.subscribe': '订阅',
    'member_profile.subscribed': '已订阅',
    'member_profile.notification.promotion': '优惠宣传',
    'member_profile.notification.order': '订单通知',
    'member_profile.subscribe.successfully': '订阅成功',
    'member_profile.subscribe.error': '订阅失败，请联络店家',
    'member_profile.line.subscribe.error.already_for_registration':
      '订阅失败，此 LINE 帐号已被其他会员注册使用，请用 LINE 登入该帐号再订阅',
    'member_profile.line.subscribe.error.different_id':
      '订阅失败，请用注册此会员的 LINE 帐号订阅',
    'member_profile.line.subscribe.error': '订阅失败，请重新登入 LINE',
    'member_profile.facebook.subscribe.error': '订阅失败，请重新登入 FB',
    'member_profile.social.subscribe.error.already_bound_to':
      '订阅失败，此社群帐号已绑定其他顾客，请联络店家解除绑定',
    'member_profile.email.subscribe.error': '订阅失败，请先输入电邮后再订阅',
    'member_profile.sms.subscribe.error': '订阅失败，请先输入手机号码后再订阅',
    'member_profile.unsubscribe.successfully': '取消订阅成功',
    'member_profile.unsubscribe.error': '取消订阅失败，请再试一次',
    'member_profile.error.unknown': '对不起！遇到非预期的状况',
    'member_profile.error.refresh': '请重新整理此页并稍后再试',
    'member_profile.retry': '重新整理',
    'member_profile.profile': '会员资料',
    'member_profile.subscription': '订阅',
    'member_profile.delivery_payment': '送货与付款资料',
    'member_profile.phone': '联络电话',
    'users.invoice_carrier': '发票载具',
    'users.electronic_invoice_carrier': '电子发票载具归户',
    'member_profile.confirm': '储存变更',
    'member_profile.cancel': '取消',
    'users.save.success': '已储存变更',
    'users.error.not_save_mobile_phone': '此手机号码尚未验证，无法储存变更',
    'verification.email.trial_merchant.reach_limit.failure':
      '商店试营运中无法发送验证邮件，如有需求请联系商店，谢谢。',
    'Subscription - Facebook - Dialog - title': '订阅 Facebook',
    'Subscription - Facebook - Dialog - info': `因应 Facebook 平台的讯息规范更新，须至 Messenger 完成订阅流程。请点按「前往订阅」，系统将自动开启 Messenger。<1 />开启 Messenger 后，请登入并<2>点按对话中的「立即开始」按钮</2>再回到本页面，即可完成订阅。 （若您曾与此商店的粉丝专页对话过，开启对话后即视为订阅成功。）`,
    'Subscription - Facebook - Dialog - cancel': '取消',
    'Subscription - Facebook - Dialog - subscribe': '前往订阅',
  },
};
